module.exports = __webpack_public_path__ + "static/media/Rocket.e7abcab7.svg";